/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { HibernationJobError } from './hibernation-job-error';
// May contain unused imports in some cases
// @ts-ignore
import type { NodeConfig } from './node-config';

/**
 * Hibernation job model
 * @export
 * @interface HibernationJob
 */
export interface HibernationJob {
    /**
     * The ID of the cluster that the hibernation job belongs to.
     * @type {string}
     * @memberof HibernationJob
     */
    'clusterId'?: string;
    /**
     * The creation time of the cluster hibernation job.
     * @type {string}
     * @memberof HibernationJob
     */
    'createTime'?: string;
    /**
     * Job error information
     * @type {HibernationJobError}
     * @memberof HibernationJob
     */
    'error'?: HibernationJobError;
    /**
     * The ID of the cluster hibernation job.
     * @type {string}
     * @memberof HibernationJob
     */
    'id'?: string;
    /**
     * Node configuration, that will be used to create cluster resumption nodes.
     * @type {NodeConfig}
     * @memberof HibernationJob
     */
    'nodeConfig'?: NodeConfig;
    /**
     * The ID of the organization that the hibernation job belongs to.
     * @type {string}
     * @memberof HibernationJob
     */
    'organizationId'?: string;
    /**
     * The state of the cluster hibernation job.
     * @type {string}
     * @memberof HibernationJob
     */
    'state'?: HibernationJobStateEnum;
    /**
     * The type of the cluster hibernation job.
     * @type {string}
     * @memberof HibernationJob
     */
    'type': HibernationJobTypeEnum;
    /**
     * The last update time of the cluster hibernation job.
     * @type {string}
     * @memberof HibernationJob
     */
    'updateTime'?: string;
}

export const HibernationJobStateEnum = {
    STATE_UNSPECIFIED: 'STATE_UNSPECIFIED',
    PENDING: 'PENDING',
    PAUSING: 'PAUSING',
    FINISHED: 'FINISHED',
    FAILED: 'FAILED',
    RESUMING: 'RESUMING'
} as const;

export type HibernationJobStateEnum = typeof HibernationJobStateEnum[keyof typeof HibernationJobStateEnum];
export const HibernationJobTypeEnum = {
    TYPE_UNSPECIFIED: 'TYPE_UNSPECIFIED',
    PAUSE: 'PAUSE',
    RESUME: 'RESUME'
} as const;

export type HibernationJobTypeEnum = typeof HibernationJobTypeEnum[keyof typeof HibernationJobTypeEnum];


